import React , { useState , useEffect,} from 'react';
import { Container } from 'react-bootstrap';
import Header from './components/header/Header';
import Sidebar from './components/sidebar/Sidebar';
import HomeScreen from './screens/homeScreen/HomeScreen';
import LoginScreen from './screens/loginScreen/LoginScreen';
import Notfound  from './Notfound';
import {Redirect, Route , Switch, } from 'react-router-dom';
import { useHistory} from 'react-router-dom';
import { useSelector } from 'react-redux'

import "./App.scss"
import WatchScreen from './screens/watchScreen/watchScreen';
import SearchScreen from './screens/SearchScreen';

const Layout = ({ children }) => {
    const [sidebar, toggleSidebar] = useState(false)
 
    const handleToggleSidebar = () => toggleSidebar(value => !value)
 
    return (
       <>
          <Header handleToggleSidebar={handleToggleSidebar} />
          <div className='app_container'>
             <Sidebar
                sidebar={sidebar}
                handleToggleSidebar={handleToggleSidebar}
             />
             <Container fluid className='app_main '>
                {children}
             </Container>
          </div>
       </>
    )
 }

function App() {
     
   const {accessToken, loading} = useSelector(state => state.auth)

    const history = useHistory();

    useEffect(() => {
       if(!accessToken && !loading){
          history.push('/auth');
       }
    }, [accessToken, loading, history]);
    
    return (
     
        <div className="app">
       
         <Switch>
                <Route path='/' exact>
                <Layout>
                <HomeScreen />
                </Layout>
                </Route>

                <Route path='/auth'>
                    <LoginScreen />
                </Route>

                <Route path='/search/:query'>
                <Layout>
                 <SearchScreen />
                </Layout>
               </Route>

               <Route path='/watch/:id' component={WatchScreen}>
                
               </Route>

               <Route>
                   <Redirect to="/">
                
                   </Redirect>
               </Route>
         </Switch>
       
         
        </div>
        
    )
}

export default App;